import { Component, OnInit } from '@angular/core';
import { ValuesComponent } from '../../landing-page/values/values.component';
import { InterlocutorsComponent } from '../../landing-page/interlocutors/interlocutors.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { PillarsComponent } from '../../landing-page/foundations/pillars.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { StrategyService } from '../../services/strategy.service';
import { Strategy } from '../../interfaces/models/strategy.model';
import { SocketService } from '../../services/socket.service';
import { AuthService } from '../../services/auth.service';
import { authUser } from '../../interfaces/auth/auth.model';
import { TranslateModule } from '@ngx-translate/core';
import { Strategy404Component } from '../../shared/components/strategy404/strategy404.component';

@Component({
  selector: 'app-defualt-strategy',
  standalone: true,

  imports: [ValuesComponent, Strategy404Component, TranslateModule, FooterComponent, InterlocutorsComponent, FooterComponent, PillarsComponent, ButtonModule, IconFieldModule, InputTextModule, InputIconModule, CommonModule, RouterModule, DropdownModule, FormsModule, RadioButtonModule],
  templateUrl: './defualt-strategy.component.html',
  styleUrl: './defualt-strategy.component.scss'
})
export class DefualtStrategyComponent implements OnInit {
  strategyOptions = [] as { name: string, strategyId: number }[];
  selectedStrategyId = 0;
  targetStrategy = {} as Strategy;
  user!: authUser;
  constructor(
    private strategyService: StrategyService,
    private socketService: SocketService,
    private authService: AuthService,
  ) {
  }
  ngOnInit(): void {
    //strategy options dropdownList
    this.strategyService.RawStrategies$.subscribe((strategies: Strategy[]) => {
      this.strategyOptions = strategies.map((x) => ({ name: x.name, strategyId: x.id }))
    })


    this.strategyService.selectedStrategy$.subscribe(selectedStrategy => {
      console.log('selectedStrategy', selectedStrategy);
      this.targetStrategy = selectedStrategy || {} as Strategy;

    })

    this.strategyService.defaultStrategy$.subscribe(defaultStrategy => {
      this.targetStrategy = defaultStrategy || {} as Strategy;
      this.selectedStrategyId = defaultStrategy?.id || 0;
    });
    this.authService.authBufferSub$.subscribe((user) => {
      this.user = user as authUser;

    })
  }
  strategyOptionsChange() {
    console.log('strategyOptionsChange');
    this.strategyService.setStrategyIdfn(this.selectedStrategyId)
    this.socketService.setRefreshNotification(this.selectedStrategyId)
  }

}
